import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.cfscript = bracketIndenting()
